module.exports = __webpack_public_path__ + "static/media/IMG_6398.aaddeef7.jpg";